import { render, staticRenderFns } from "./SocialDataPatients.vue?vue&type=template&id=b3b3f87c&scoped=true"
import script from "./SocialDataPatients.vue?vue&type=script&lang=js"
export * from "./SocialDataPatients.vue?vue&type=script&lang=js"
import style0 from "./SocialDataPatients.vue?vue&type=style&index=0&id=b3b3f87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b3f87c",
  null
  
)

export default component.exports